exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-component[data-v-4cb822da] {\n  background-color: #e9f1fb;\n  border-radius: 12px;\n  padding: 22px;\n  max-width: 506px;\n}\n.drop-container[data-v-4cb822da] {\n  border: dashed 2px #d9d9d9;\n}\n.file-component.has-error[data-v-4cb822da] {\n  background: #fff3f3;\n}\n.preview[data-v-4cb822da] {\n  padding: 0 15px 0 0;\n}\n.preview img[data-v-4cb822da] {\n  width: 100%;\n}\n.preview > div.icon[data-v-4cb822da] {\n  padding: 8px 8px 13px 12px;\n  font-size: 29px;\n  border: solid 2px #00000014;\n  border-radius: 3px;\n  color: #0000009c;\n}\n.error[data-v-4cb822da] {\n  color: #ff000d;\n  font-weight: 400;\n}", ""]);

// exports
